// src/api/inventory/inventoryTransferQueryApi.ts
import apiHandler from "../core/apiHandler";

const inventoryTransferQueryApi = apiHandler("inventory/transfers/query");

export default inventoryTransferQueryApi;
